import { Col, Divider, Row, Avatar } from 'antd'
import Flex from 'components/Flex'
import {
  Editor,
  FlexContain,
  FlexWrap,
  InfoText,
  LeftCol,
  OneLinerDiv,
  SocialMeadiaIconsFlex,
  SubtitleLarge,
  SubtitleMedium,
  TitleMedium,
  VerticalDivider,
  EditorContent,
} from 'modules/ViewRole/Style/style'
import React from 'react'
import Location from 'components/icons/LocationIcon'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { TextMedium1 } from 'modules/ViewSingleRole/Style/style'
import ConstructionIcon from 'components/icons/ConstructionIcon'

import DomainDisabled from 'assets/icons/DomainDisabled'
import BrowseDefaultIcon from 'components/icons/BrowseDefaultIcon'
import ContactIcon from 'components/icons/ContactIcon'
import DateIcon from 'components/icons/DateIcon'
import FaceBookIcon from 'components/icons/FacebookIcon'
import Instagram from 'components/icons/Instagram'
import LinkedInIcon from 'components/icons/LinkedIcon'
import Twitter from 'components/icons/Twitter'
import ReactPlayer from 'react-player'
import Facebook from 'components/icons/SocialMediaIcons/Facebook.svg'
import Instagramicon from 'components/icons/SocialMediaIcons/Instagramicon.svg'
import Interneticon from 'components/icons/SocialMediaIcons/Interneticon.svg'
import LinkedInIcon1 from 'components/icons/SocialMediaIcons/LinkedInIcon.svg'
import TwitterIcon from 'components/icons/SocialMediaIcons/TwitterIcon.svg'
import Youtubeicon from 'components/icons/SocialMediaIcons/Youtubeicon.svg'


const NavigateSpan = styled.span`
  cursor: pointer;
`
const AboutCompany = ({ viewRoleData }) => {
  const getSocilaMediaIcon = media => {
    if (media?.media == 'Facebook') {
      return <Avatar size={24} src={<FaceBookIcon />} />
    } else if (media?.media == 'Linkedin') {
      return <Avatar size={24} src={<LinkedInIcon />} />
    } else if (media?.media == 'Instagram') {
      return <Avatar size={24} src={<Instagram />} />
    }

    return <Avatar size={24} src={<Twitter />} />
  }
  const onClickLink = link => {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      link = 'https://' + link
    }

    // Open the link in a new tab
    const newTab = window.open('', '_blank')

    // Set the new tab's location to the link after a delay
    setTimeout(() => {
      newTab.location.href = link
    }, 100)
  }

  return (
    <Row>
      <LeftCol span={22}>
        <TextMedium1>{viewRoleData?.role?.corporate?.name ?? viewRoleData?.role?.company?.companyName}</TextMedium1>
        <div style={{ marginRight: '10px', marginTop: '5px' }}>
          {viewRoleData?.role?.corporate?.website || viewRoleData?.role?.company?.website  && (
            <NavigateSpan
              onClick={() =>
                onClickLink(viewRoleData?.role?.corporate?.website ??  viewRoleData?.role?.company?.website)
              }
            >
              <img
                src={Interneticon}
                alt="Internet Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}

          {viewRoleData?.role?.company?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'facebook'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  viewRoleData?.role?.company?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'facebook'
                  )?.link
                )
              }
            >
              <img
                src={Facebook} // Replace with your actual Facebook icon import or path
                alt="Facebook Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {viewRoleData?.role?.company?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'instagram'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  viewRoleData?.role?.company?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'instagram'
                  )?.link
                )
              }
            >
              <img
                src={Instagramicon} // Replace with your actual Instagram icon import or path
                alt="Instagram Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {viewRoleData?.role?.company?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'linkedin'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  viewRoleData?.role?.company?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'linkedin'
                  )?.link
                )
              }
            >
              <img
                src={LinkedInIcon1} // Replace with your actual LinkedIn icon import or path
                alt="LinkedIn Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {viewRoleData?.role?.company?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'youtube'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  viewRoleData?.role?.company?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'youtube'
                  )?.link
                )
              }
            >
              <img
                src={Youtubeicon} // Replace with your actual YouTube icon import or path
                alt="YouTube Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
          {viewRoleData?.role?.company?.socialDetails?.some(
            item => item?.media?.toLowerCase() === 'xlink'
          ) && (
            <NavigateSpan
              onClick={() =>
                onClickLink(
                  viewRoleData?.role?.company?.socialDetails?.find(
                    item => item?.media?.toLowerCase() === 'xlink'
                  )?.link
                )
              }
            >
              <img
                src={TwitterIcon} // Replace with your actual Twitter icon import or path
                alt="Twitter Icon"
                style={{ width: '20px', height: '20px', marginRight: '5px' }}
              />
            </NavigateSpan>
          )}
        </div>
       
        <Editor>
          <EditorContent
            dangerouslySetInnerHTML={{
              __html: viewRoleData?.role?.corporate?.longDescription || viewRoleData?.role?.company?.description,
            }}
          />
        </Editor>

        {viewRoleData?.role?.corporate?.corporateVideoLink && (
          <ReactPlayer
            controls
            width="100%"
            height="450px"
            url={viewRoleData?.role?.corporate?.corporateVideoLink}
          />
        )}
      </LeftCol>
      {/* <Col span={8}>
          <br></br>
          <Flex>
            <Avatar size={20} src={<ConstructionIcon />} />
            &nbsp;&nbsp;
            <Name>Other Details</Name>
          </Flex>
          <PopHeading>Company Type</PopHeading>
          <PopSubHeading>
            {viewRoleData?.role?.corporate?.corporateType}
          </PopSubHeading>
          <PopHeading>Established in</PopHeading>
          <PopSubHeading>
            {viewRoleData?.role?.corporate?.establishedYear}
          </PopSubHeading>

          <Divider />
          <div>
            <FlexWrap gap="10px" centerVertically>
              <Location />
              <SubtitleMedium>Location</SubtitleMedium>
            </FlexWrap>
            <br></br>
            <ul>
              <li>{viewRoleData?.role?.corporate?.city}</li>
            </ul>
          </div>

          <Divider />
          <FlexWrap gap="10px" centerVertically>
            <BrowseDefaultIcon />
            <SubtitleMedium>Connect</SubtitleMedium>
          </FlexWrap>

          <InfoText>{viewRoleData?.role?.corporate?.website}</InfoText>

          <br></br>
          <SocialMeadiaIconsFlex>
            {viewRoleData?.role?.corporate?.socialMedia?.length
              ? viewRoleData?.role?.corporate?.socialMedia?.map(
                  (media, index) => (
                    <a href={media?.link} target="_blank" key={index+"socialMedia"}>
                      <Avatar
                        background
                        src={getSocilaMediaIcon(media)}
                        size={25}
                        IconName={'I'}
                        font={18}
                      />
                    </a>
                  )
                )
              : null}
          </SocialMeadiaIconsFlex>
        </Col> */}
    </Row>
  )
}

export default AboutCompany
